import React from 'react'

/* 
  used in
  #1 /moremenu ==> more page from menu ==> user profile card section
*/
function UserProfileCard() {
  return (
    <div className="profile_info pse_sm mt-0">
      <div className="mt-4 mb-4">
        <div className="profile_info_img shimmerBG shimmer-icon-lg">
        </div>
      </div>

      <div className="profile_info_desc">
        <div className="message section_title mb-0 text-ellipsis shimmerBG shimmer-text-sm w-60 mb-2">
        </div>
        <div className="profile_name text-ellipsis section_title mb-0 text-ellipsis shimmerBG shimmer-text-sm w-40 mb-2">
        </div>
      </div>
    </div>
  )
}

export default UserProfileCard